import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import { Button } from "@/shared/ui";

type Props = {
  className?: string;
  onSubmit: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  disabled: boolean;
};

export default function GasStationButtons({
  className,
  onSubmit,
  disabled,
  onCancel,
  isSubmitting,
}: Props) {
  const { t } = useTranslation("gasStation");

  return (
    <div className={cn("grid grid-cols-2 gap-1.5", className)}>
      <Button className="h-11" disabled={disabled} loading={isSubmitting} onClick={onSubmit}>
        {t("gasStation.pay")}
      </Button>
      <Button className="h-11" color="gray" variant="soft" onClick={onCancel}>
        {t("gasStation.exit")}
      </Button>
    </div>
  );
}
